<template>
    <div class="card-container">
        <div class="card-option">
            <van-empty description="还未办理油卡"/>
            <van-button block class="apply-card-button" :to="{name: 'CardHandle'}">一键办卡</van-button>
            <van-button block class="apply-card-button" :to="{name: 'Binding'}">油卡绑定</van-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ApplyCard',
        methods: {}
    }
</script>

<style lang="scss" scoped>
    @import '../../style/base.scss';
    @import '../../style/themeify.scss';
    *{
        @include themeify{
            .apply-card-button {
                color: #FFF;
                border-radius: 1rem;
                height: 1rem;
                background: linear-gradient(180deg, themed('colorGradientLeft') 0%, themed('colorGradientRight') 100%);
            }
        }
    }
    .card-container {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;

        .van-empty {
            padding-top: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/beilin/ApplyCard.vue